var _defs, _rect, _rect2, _ellipse, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiseBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    width: 1080,
    height: 1080,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#111119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a0a12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-g",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1068,
    width: 1080,
    height: 8,
    fill: "#ff5722",
    opacity: 0.9
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 540,
    cy: 500,
    rx: 320,
    ry: 120,
    fill: "#ff5722",
    opacity: 0.04
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 620,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 360,
    fontWeight: 700,
    fill: "url(#text-g)",
    textAnchor: "middle",
    letterSpacing: -10,
    opacity: 0.97
  }, "mise")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 760,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 36,
    fill: "rgba(255,255,255,0.35)",
    textAnchor: "middle",
    letterSpacing: 8
  }, "MISE \xB7 mise.zabrown.com")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiseBanner);
export default __webpack_public_path__ + "static/media/mise-banner.e29d1f6a9b9f0a1a72957a042c03dd31.svg";
export { ForwardRef as ReactComponent };